export const SETTINGS_SIDEBAR_WIDTH = 80;
